export const CONSTANTS = {
  acceptedImageTypes: ["image/jpeg", "image/png", "image/gif", "image/webp"],
  tooltip: {
    underline:
      "underline decoration-dashed decoration-tooltip-underline decoration-1 underline-offset-2",
  },
}
